import { motion } from "framer-motion";

export function Header({ t, lang, setLang, onBrand, onAbout, dim }) {
  return (
    <motion.header
      data-testid="site-header"
      initial={false}
      animate={{ opacity: dim ? 0 : 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      style={{ pointerEvents: dim ? "none" : "auto" }}
      className="fixed top-0 left-0 w-full z-50 flex justify-between items-center px-6 md:px-12 py-6 md:py-8 mix-blend-difference"
    >
      <button
        data-testid="brand-btn"
        onClick={onBrand}
        className="font-display text-sm md:text-base font-medium tracking-[0.14em] text-white"
      >
        BAUHAUS CO.
      </button>

      <nav className="flex items-center gap-5 md:gap-8 text-white">
        <button
          data-testid="nav-about"
          onClick={onAbout}
          className="text-xs md:text-sm tracking-wide opacity-80 hover:opacity-100 transition-opacity"
        >
          {t.nav.about}
        </button>

        <span className="mx-1 h-3 w-px bg-white/30" />

        <div className="flex items-center gap-2 text-xs tracking-wide">
          <button
            data-testid="lang-en"
            onClick={() => setLang("en")}
            className={lang === "en" ? "opacity-100" : "opacity-40 hover:opacity-70 transition-opacity"}
          >
            EN
          </button>
          <span className="opacity-30">/</span>
          <button
            data-testid="lang-pt"
            onClick={() => setLang("pt")}
            className={lang === "pt" ? "opacity-100" : "opacity-40 hover:opacity-70 transition-opacity"}
          >
            PT
          </button>
        </div>
      </nav>
    </motion.header>
  );
}
